import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import VisibilitySensor from "react-visibility-sensor";

import map from "../../../assets/img/landingPageThree/sectionThree/map.webp";
import mapButton from "src/assets/img/components/button.webp";
import mapPin from "../../../assets/img/landingPageThree/sectionThree/map-pin.webp";

function SectionThree() {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={200}>
      <div id="map" className="sectionThree">
        <div className="sectionThree1">
          <img
            className={`${isVisible ? "visible" : ""}`}
            src={map}
            alt=""
            width={"700px"}
            height={"700px"}
          />
          <div className={`pin1 pin ${isVisible ? "visible" : ""}`}>
            <img src={mapPin} alt="" width={"40px"} height={"40px"} />
            <div className="card1 card">
              <h1>{t("map_branch")} Recife - PE</h1>
              <p>
                {t("map_address")} Av. Fernando Simoes Barbosa, 266, Sala 203, Boa
                Viagem - CEP 51.020-390
              </p>
              <a href="https://g.co/kgs/TC13ySC"
                target="_blank"
                rel="noreferrer"
              >
                {t("lp3_map_know_unit")}
              </a>
            </div>
          </div>
          <div className={`pin4 pin ${isVisible ? "visible" : ""}`}>
            <img src={mapPin} alt="" width={"40px"} height={"40px"} />
            <div className="card4 card">
              <h1>{t("map_branch")} Paranaíba - MS</h1>
              <p>
                {t("map_address")} Rod. BR 158 KM 89, S/N, Km 90 Anexo Auto Posto
                Daniel, Santo Antonio - CEP 79.500-000
              </p>
              <a href="https://g.co/kgs/FycBaVx"
                target="_blank"
                rel="noreferrer"
              >
                {t("lp3_map_know_unit")}
              </a>
            </div>
          </div>
          {/* <div className={`pin3 pin ${isVisible ? "visible" : ""}`}>
            <img src={mapPin} alt="" width={"40px"} height={"40px"} />
            <div className="card3 card">
              <h1>{t("map_branch")} Taboão da Serra - SP</h1>
              <p>
                {t("map_address")} Av. Vida Nova, 28, Bloco A sala 609 Cond Centro
                Empvida Nova, Jardim Maria Rosa - CEP 06.764-045
              </p>
              <a href="https://g.co/kgs/HsgzEBX"
                target="_blank"
                rel="noreferrer"
              >
                {t("lp3_map_know_unit")}
              </a>
            </div>
          </div> */}
          <div className={`pin10 pin ${isVisible ? "visible" : ""}`}>
            <img src={mapPin} alt="" width={"40px"} height={"40px"} />
            <div className="card10 card">
              <h1>{t("map_branch")} Jacareí - SP</h1>
              <p>
                  {t("map_address")} Av. Plinio Marcos, 65 - Piso Superior - Sala 6 - Vila Branca - CEP 12301-350
              </p>
              <a href="https://g.co/kgs/wqbCVkZ"
                target="_blank"
                rel="noreferrer"
              >
                {t("lp3_map_know_unit")}
              </a>
            </div>
          </div>
          <div className={`pin6 pin ${isVisible ? "visible" : ""}`}>
            <img src={mapPin} alt="" width={"40px"} height={"40px"} />
            <div className="card6 card">
              <h1>{t("map_branch")} Juiz de Fora - MG</h1>
              <p>
                {t("map_address")} Av. Presidente Juscelino Kubitscheck, 6911, Sala
                208, Benfica - CEP 36.092-060
              </p>
              <a
                href="https://g.co/kgs/iGpL8Av"
                target="_blank"
                rel="noreferrer"
              >
                {t("lp3_map_know_unit")}
              </a>
            </div>
          </div>
          <div className={`pin7 pin ${isVisible ? "visible" : ""}`}>
            <img src={mapPin} alt="" width={"40px"} height={"40px"} />
            <div className="card7 card">
              <h1>{t("map_branch")} Resende - RJ</h1>
              <p>
                {t("map_address")} Av. Tenente Coronel Adalberto Mendes, 682, Loja QA2
                LB, Liberdade, Resende - CEP 27.521-131
              </p>
              <a
                href="https://g.co/kgs/nJ3vkUw"
                target="_blank"
                rel="noreferrer"
              >
                {t("lp3_map_know_unit")}
              </a>
            </div>
          </div>
          <div className={`pin5 pin ${isVisible ? "visible" : ""}`}>
            <img src={mapPin} alt="" width={"40px"} height={"40px"} />
            <div className="card5 card">
              <h1>{t("map_branch")} Campina Grande do Sul - PR</h1>
              <p>
                {t("map_address")} Rod. Régis Bittencourt, S/N, KM 31, Sala 06, Anexo
                ao posto Pelanda, Ribeirão Grande - CEP 83.430-000
              </p>
              <a
                href="https://g.co/kgs/qW23wxZ"
                target="_blank"
                rel="noreferrer"
              >
                {t("lp3_map_know_unit")}
              </a>
            </div>
          </div>
          <div className={`pin8 pin ${isVisible ? "visible" : ""}`}>
            <img src={mapPin} alt="" width={"40px"} height={"40px"} />
            <div className="card8 card">
              <h1>{t("map_branch")} Garuva - SC</h1>
              <p>
                {t("map_address")} Rod. SC 417 Maximo Jamur, 11805, Cond Braspark
                Galpão C Modulo 1, Mina Velha - CEP 89.248-000
              </p>
              <a
                href="https://g.co/kgs/Nan9MyA"
                target="_blank"
                rel="noreferrer"
              >
                {t("lp3_map_know_unit")}
              </a>
            </div>
          </div>
          <div className={`pin2 pin ${isVisible ? "visible" : ""}`}>
            <img src={mapPin} alt="" width={"40px"} height={"40px"} />
            <div className="card2 card">
              <h1>{t("map_matriz")}</h1>
              <p>
                {t("map_address")} Rua Francisco Reis, 1402, Cordeiros - CEP 88.311-750
              </p>
              <a
                href="https://g.co/kgs/XRjeGrY"
                target="_blank"
                rel="noreferrer"
              >
                {t("lp3_map_know_matrix")}
              </a>
            </div>
          </div>
          <div className={`pin11 pin ${isVisible ? "visible" : ""}`}>
            <img src={mapPin} alt="" width={"40px"} height={"40px"} />
            <div className="card11 card">
              <h1>{t("map_csl")}</h1>
              <p>
                {t("map_address")} Rua José Natal Cugik, nº 501 Bairro Rio Novo , CEP 88312-600, Itajaí/SC
              </p>
              <a
                href="https://g.co/kgs/8QWKJro"
                target="_blank"
                rel="noreferrer"
              >
                {t("lp3_map_know_csl")}
              </a>
            </div>
          </div>
          <div className={`pin9 pin ${isVisible ? "visible" : ""}`}>
            <img src={mapPin} alt="" width={"40px"} height={"40px"} />
            <div className="card9 card">
              <h1>{t("map_branch")} Carazinho - RS</h1>
              <p>
                {t("map_address")} Rod Gov. Leonel de Moura Brizola - BR386 - KM 180, Sala 04, Capão do leão - CEP 99.500-000
              </p>
              <a
                href="https://g.co/kgs/2rTWzxy"
                target="_blank"
                rel="noreferrer"
              >
                {t("lp3_map_know_unit")}
              </a>
            </div>
          </div>
          <div className={`pin12 pin ${isVisible ? "visible" : ""}`}>
            <img src={mapPin} alt="" width={"40px"} height={"40px"} />
            <div className="card12 card">
              <h1>{t("map_branch")} Santos - SP</h1>
              <p>
                {t("map_address")} Rua Alexandre Gusmão, 11 – Sala 1709 – Valongo - CEP
                11010-340
              </p>
              {/* <a
                href="https://g.co/kgs/2rTWzxy"
                target="_blank"
                rel="noreferrer"
              >
                {t("lp3_map_know_unit")}
              </a> */}
            </div>
          </div>
                      <div className={`pin13 pin ${isVisible ? "visible" : ""}`}>
              <img src={mapPin} alt="" width={"40px"} height={"40px"} />
              <div className="card13 card">
                <h1>{t("map_branch")} Luis Eduardo Magalhães - BA</h1>
                <p>
                  {t("map_address")} Rua Flamboyant, 141 – Jardim Primavera - CEP
                  47852-010
                </p>
              </div>
            </div>
            <div className={`pin14 pin ${isVisible ? "visible" : ""}`}>
              <img src={mapPin} alt="" width={"40px"} height={"40px"} />
              <div className="card14 card">
                <h1>{t("map_branch")} Cuiabá - MT</h1>
                <p>
                  {t("map_address")} Av. Ayrton Senna da Silva, KM 397.4 – Distrito industrial - CEP
                  78098-282
                </p>
              </div>
            </div>
            <div className={`pin15 pin ${isVisible ? "visible" : ""}`}>
              <img src={mapPin} alt="" width={"40px"} height={"40px"} />
              <div className="card15 card">
                <h1>{t("map_branch")} Uruguaiana - RS</h1>
                <p>
                  {t("map_address")} R. Gen. San Martín, 3700 – Distrito Rodoviário
                </p>
                <a
                  href="https://maps.app.goo.gl/xfabRZSHtd62Q7Sq7"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t("lp3_map_know_unit")}
                </a>
              </div>
            </div>
        </div>
        <div className="sectionThree2">
          <h1 className={`${isVisible ? "visible" : ""}`}>
            {t("lp3_map_title")}
          </h1>
          <p className={`${isVisible ? "visible" : ""}`}>
            {t("lp3_map_text1")}
          </p>
          <span className={`${isVisible ? "visible" : ""}`}>
            {t("lp3_map_text2")}
          </span>
          <a href="/contact" reloadDocument className={`${isVisible ? "visible" : ""}`}>
            <img
              className={`${isVisible ? "visible" : ""}`}
              src={mapButton}
              alt=""
              width={"288px"}
              height={"106px"}
            />
            <p>{t("lp3_map_contact")}</p>
          </a>
        </div>
      </div>
    </VisibilitySensor>
  );
}

export default SectionThree;
